import React, { useState, useEffect, useRef, useCallback, use } from "react";
import "./App.css";
import { useNavigate, useLocation } from 'react-router-dom'; // No Routes/Route/useParams needed here directly
import CarouselGallery from "./components/CarouselGallery/CarouselGallery";
import GridGallery from "./components/GridGallery/GridGallery";
import Screensaver from "./components/Screensaver/Screensaver"; // Import the Screensaver component
import ZoomModal from "./components/ZoomModal/ZoomModal"; // Import ZoomModal
import useGlobalStore from './store/globalStore';



// this is not what the json structure looks like
const initialSlides = [
  {
    image: "https://picsum.photos/600/450?random=1",
    title: "Loading...",
    subtitle: "Please wait or download assets",
    description: "Gallery content will appear here.",
    type: "image",
    id: 0,
  },
];

const App = () => {
  const jsonUrl = "https://unsw-foh-cms.s3.ap-southeast-2.amazonaws.com/endpoints/object.json";// "https://awm-cms-test.s3.ap-southeast-2.amazonaws.com/endpoints/showcase_label.json";
  // --- State for Download/Data ---
  const [downloadedFile, setDownloadedFile] = useState(null);
  const [assetDownloadProgress, setAssetDownloadProgress] = useState(null);
  const [assetDownloadComplete, setAssetDownloadComplete] = useState(null);
  const [assetDownloadError, setAssetDownloadError] = useState(null);
  const [showDownloadStatus, setShowDownloadStatus] = useState(true); // State for status UI visibility
  const [videos, setVideos] = useState([]);
  const [appData, setAppData] = useState(null);
  const [slides, setSlides] = useState(initialSlides);
  const [screensaverSlides, setScreensaverSlides] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  
  // --- global state vars ---
  // Select only the string state value
  const globalString = useGlobalStore((state) => state.globalString);
  const setStringValue = useGlobalStore((state) => state.setStringValue);
  const isElectron = useGlobalStore((state) => state.isElectron);
  const setElectron = useGlobalStore((state) => state.setElectron);
  const isDesktop = useGlobalStore((state) => state.isDesktop);
  const setDesktop = useGlobalStore((state) => state.setDesktop);
  const setSmallMobile = useGlobalStore((state) => state.setSmallMobile);
  const setDisableTouchScreensaver = useGlobalStore((state) => state.setDisableTouchScreensaver);
  const isDisableTouchScreensaver = useGlobalStore((state) => state.isDisableTouchScreensaver);
  const setDisableTouchScreensaverTexts = useGlobalStore((state) => state.setDisableTouchScreensaverTexts); // custom heading + subheading from hold state
  const setExhibitionTitle = useGlobalStore((state) => state.setExhibitionTitle);
  const audioQrCode = useGlobalStore((state) => state.audioQrCode);
  //const setAudioQrCode = useGlobalStore((state) => state.setAudioQrCode);
  //const exhibitionInfoId = useGlobalStore((state) => state.exhibitionInfoId); // custom id for exhibition info overlay


  // --- State for View Mode ---
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'carousel'
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(-1);
  const [qrIndex, setQrIndex] = useState(-1);
  const [qrMode, setQRMode] = useState(false); // 'grid' or 'carousel'
  //const [showScreensaver, setShowScreensaver] = useState(false); // State for screensaver visibility
  const showScreensaver = useGlobalStore((state) => state.showScreensaver); // NEW: Global state
  const setShowScreensaver = useGlobalStore((state) => state.setShowScreensaver); // NEW: Global setter

  // --- State for initial filter from URL ---
  const [initialFilter, setInitialFilter] = useState(null);
  const [triggerScreensaverAfterInitialLoad, setTriggerScreensaverAfterInitialLoad] = useState(false);
  const [disableTouchFlag, setDisableTouchFlag] = useState(false);
  // const [cmsFlagDisableTouch, setCmsFlagDisableTouch] = useState(false);

  // --- State for ZoomModal (lifted up) ---
  const [modalContent, setModalContent] = useState(null); // { src, type, caption, id } or null

  // --- Ref to track initial load ---
  const initialLoadDone = useRef(false);
  const carouselSectionRef = useRef(null); // Ref for the carousel section div
  const gridSectionRef = useRef(null); // Ref for the carousel section div
  const zoomModalRef = useRef(null); // Ref for ZoomModal
  

  // --- Ref for inactivity timer ---
  const inactivityTimerRef = useRef(null);

  // --- custom check for stories-about type, which changes the carouselgallery display to a modal view instead of fullscreen
  const checkCarouselIsModal = (index) => {
    //return false;

    const slide = slides[index];
    if (slide && slide.type === 'stories-qr') {  
      return true;
    }
    return false;
  };
  
  // --- when rendering the carousel, the starting index is always 0. BUT, if we also render the modal (eg. via url) then we need the initialIndex to be calculated from the custom slide id eg. gallery/251/850 = find index for id 850
  // this function is only for direct url navigation when we need a zoom modal (2nd level) on top of a carouselgallery. All it does is allow the Swiper in carousel to set the initialSlide to whatever matches in the modal.
  // in other words, this is just setting the correct slide index in the carousel and will only be noticeable AFTER closing the zoom modal as the carousel will be on the matching slide from the modal.
  const getInitialIndexForCarouselFromModalId = (index) => {
    const slide = slides[index];
    if (slide) {
      if(modalContent && slide.media_item && Array.isArray(slide.media_item)) {
        let modalId = modalContent.id; // eg. 815
        const itemIndex = slide.media_item.findIndex(s => String(s.id) === String(modalId));
        console.log("getInitialIndexForCarouselFromModalId: Found custom media item index from modalId", itemIndex, modalId);
        if (itemIndex !== -1) return itemIndex;
      }
    }
    return 0;
  };

  // --- Handler for grid image clicks ---
  const handleGridImageClick = (index) => {
    const slide = slides[index];
    if (slide && typeof slide.urlId !== 'undefined') {
      console.log(`[App.js] Grid image clicked for slide ID ${slide.urlId}. Navigating. From index ${index}.`);
      navigate(`/gallery/${slide.urlId}`);
    } else {
      console.warn("[App.js] Clicked slide has no ID, cannot navigate:", slide);
    }
  };

  // --- Handler to switch back to grid view ---
  const handleBackToGrid = () => {
    console.log("[App.js] Navigating back to grid view (/gallery).");
    // setSelectedSlideIndex(-1); // MOVED: This will now be set after the transition ends
    // setViewMode('grid'); // This will be handled by the URL effect
    // The useEffect that listens to transitionend on carouselSectionRef will still
    // set selectedSlideIndex to -1 after the animation.
    setQRMode(false);
    navigate("/gallery");

    // if (gridSectionRef.current) {
    //   console.log("gridSectionRef.current.focus();");
    //   gridSectionRef.current.focus();
    // }
  };

  const handleBackFromQR = () => {
    setQRMode(false);
    // Trigger function in ZoomModal when QR video is closed
    if (zoomModalRef.current) {
      zoomModalRef.current.onQRClose();
    }
  }

  // --- Handlers for ZoomModal, requested from CarouselGallery ---
  const handleRequestOpenMediaItem = useCallback((itemToOpen) => {
    // This function now just sets the modal content.
    // URL update will be handled by the component initiating the request (e.g., CarouselGallery)
    // or by the URL sync effect if opened directly via URL.
    if (itemToOpen && typeof itemToOpen.id !== 'undefined') {
      console.log(`[App.js] Request to open media item ${itemToOpen.id} in modal.`);
      setModalContent({
        src: itemToOpen.type === 'video' ? (itemToOpen.video_file || itemToOpen.video) : itemToOpen.full_resolution_image,
        type: itemToOpen.type,
        caption: itemToOpen.short_caption || itemToOpen.text || '',
        id: String(itemToOpen.id), // Ensure ID is a string for comparisons
        srt: itemToOpen.subtitle_file,
        qr: (itemToOpen.audio_qr_code) ? itemToOpen.audio_qr_code : '',
      });
    } else {
      console.warn("[App.js] Invalid request to open media item in modal:", itemToOpen);
    }
  }, []); // setModalContent is stable, so no dependencies needed here

  const handleRequestQRClick = useCallback((q) => {
    console.log("[App.js] Request to open QR modal.", viewMode, q);

    // TODO: open ANOTHER carousel modal with the custom video qr code, same as the exhibition one
    // find the index for the qr code
    const qrIndex = slides.findIndex(slide => slide.type === 'video-qr' );
    if(qrIndex !== -1) setQrIndex(qrIndex);

    //handleGridImageClick(12);
    //setViewMode("qr-video");
    //setAudioQrCode(q);
    setQRMode(true);

    console.log("qrIndex/qrImage", qrIndex, audioQrCode);

  
  }, [slides, audioQrCode]);

  
  

  

  const getSelectedScreensaverSlides =  useCallback(() => {
    console.log("getSelectedScreensaverSlides", screensaverSlides, initialFilter);
    if (screensaverSlides && screensaverSlides.length > 0) {
      const selected = screensaverSlides.filter(slide => {
        return slide.id == initialFilter ;
      });
      console.log("getSelectedScreensaverSlides", selected);
      if(selected && selected.length > 0) return selected[0];
    }
    return null;
    
   }, [screensaverSlides, initialFilter]); // initialSlides is a constant, setShowScreensaver is stable

  // --- Handler to start the screensaver (memoized) ---
  const handleStartScreensaver = useCallback(() => {
    console.log("handleStartScreensaver", screensaverSlides);
    if (screensaverSlides && screensaverSlides.length > 0) { // Ensure we have actual slides
      console.log("Starting screensaver (manual or inactivity).", viewMode);
      
      setShowScreensaver(true);
      if (viewMode === 'carousel') {
        setTimeout(() => {
          //   //console.log("do we have modal content?", modalContent);
          //   setModalContent(null); 
          // setViewMode('grid');
          handleBackToGrid();        
        }, 750);
      }

      // Clear the inactivity timer if it's running, as screensaver is now active
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    } else {
      console.log("No slides available to start screensaver or still on initial slides.");
    }
  }, [screensaverSlides, viewMode]); // initialSlides is a constant, setShowScreensaver is stable

  const handleCloseScreensaver = useCallback(() => {
    console.log("Closing screensaver (manual).", viewMode, modalContent);
    //() => { setShowScreensaver(false); /* resetInactivityTimer(); // Timer reset is handled by useEffect when showScreensaver changes */ }
    setShowScreensaver(false);

    // need to reset
    // if currently showing a carousel need to close and reset to grid
    if(modalContent) {
      //setModalContent(null);   
        // console.log("Yes: we have modal content for some reason- force clsoe", modalContent);
        // setTimeout(() => {
        //   //console.log("do we have modal content?", modalContent);
        //   setModalContent(null);         
        // }, 10);
      }
    if (viewMode === 'carousel') {
      //handleBackToGrid();
    //  setViewMode('grid');
      // setTimeout(() => {
      //   //setShowScreensaver(false);
      // }, 1000);
    } else {
      //setShowScreensaver(false);
    }
    
  }, [viewMode]);

  // --- Function to reset the inactivity timer (memoized) ---
  const resetInactivityTimer = useCallback(() => {
    if(!isElectron) {
      // no screensaver for web
      return;
    }

    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    // Only set a new timer if the screensaver is NOT active
    // and if there are slides available (not the initial placeholder ones)
    if (!showScreensaver && screensaverSlides && screensaverSlides.length > 0) {
      console.log("start inactivity timeout!");
      inactivityTimerRef.current = setTimeout(() => {
        console.log("Inactivity timeout reached, attempting to start screensaver.");
        
        if(zoomModalRef && zoomModalRef.current.isVideoPlaying()) {
          console.log("YES video playing - do not open screensaver", zoomModalRef.current.isVideoPlaying());
          resetInactivityTimer();
        } else {
          handleStartScreensaver();
        }
        
      }, 90000); // 10-90 seconds (10000 ms)
    }
  }, [showScreensaver, screensaverSlides, handleStartScreensaver, zoomModalRef]); // initialSlides is a constant

  const handleRequestCloseModal = useCallback(() => {
    console.log("[App.js] Request to close modal.");
    const pathParts = location.pathname.split('/').filter(Boolean);
    const currentItemId = pathParts[1]; // This would be the ID of the item in the carousel view
    const queryParams = new URLSearchParams(location.search);
    const mediaIdFromQuery = queryParams.get('media');

    // FIXED: this is causing the modal to blink during fadeout
    //setModalContent(null); // Close the modal first
    console.log(mediaIdFromQuery, currentItemId);

    // restart inactivity timer for videos auto close
    // if this was interaction closed its already called this, but if the video auto-closed then we need to reset
    resetInactivityTimer();

    if (mediaIdFromQuery && currentItemId) {
      // If modal was opened via ?media=mediaId for an item within a carousel (story)
      console.log(`[App.js] Modal closed, was for mediaId ${mediaIdFromQuery} within item ${currentItemId}. Navigating to /gallery/${currentItemId}.`);
      navigate(`/gallery/${currentItemId}`); // Go bacZoomModalk to the carousel view for the parent item
      //setModalContent(null); 

      // FIXED: if mediaIdFromQuery and currentItemId are both equal, then it's not closing the popup??? eg. http://localhost:3000/#/gallery/3?media=3 doesnt close, but http://localhost:3000/#/gallery/3?media=4 does.
      if(modalContent) {
        console.log("Yes: we have modal content for some reason- force clsoe", modalContent);
        setTimeout(() => {
          //console.log("do we have modal content?", modalContent);
          setModalContent(null);         
        }, 10);
      }
      

    } else if (currentItemId) {
      // If modal was for a direct item (no ?media= in URL, but /gallery/:itemId was present, and this item was directly viewable)
      // This implies the selectedSlideIndex pointed to a direct image/video.
      //console.log('currentItemId', currentItemId, selectedSlideIndex, slides);
      if (selectedSlideIndex !== -1 && slides[selectedSlideIndex]) {
        const currentCarouselSlide = slides[selectedSlideIndex];
        if ((currentCarouselSlide.type === 'image' || currentCarouselSlide.type === 'video') &&
            !(currentCarouselSlide.media_item && currentCarouselSlide.media_item.length > 0)) {
          console.log("[App.js] Modal closed for a direct image/video type. Navigating to /gallery.");
          navigate("/gallery"); // Go back to the grid view
        }
      }
    } else {
      // Fallback or if modal was opened in a context not tied to /gallery/:itemId (e.g. from screensaver - though less likely with current flow)
      console.log("[App.js] Modal closed, no specific item context in URL to revert to /gallery.");
    }
  }, [navigate, location.pathname, location.search, selectedSlideIndex, slides, resetInactivityTimer]);



  // --- Effect for managing inactivity timer and event listeners ---
  useEffect(() => {
    if(!isElectron) {
      // no screensaver for web
      return;
    }
    const activityEvents = ['mousedown', 'click', 'touchstart', 'keydown', 'scroll']; //'mousemove', 
    const handleActivity = () => resetInactivityTimer();

    if (showScreensaver) { // If screensaver is active, clear timer and do nothing else
      if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
      return; // No listeners or new timer if screensaver is on
    }

    resetInactivityTimer(); // Start or reset the timer
    activityEvents.forEach(event => window.addEventListener(event, handleActivity, { passive: true }));


    return () => { // Cleanup
      activityEvents.forEach(event => window.removeEventListener(event, handleActivity, { passive: true }));
      if (inactivityTimerRef.current) clearTimeout(inactivityTimerRef.current);
    };
  }, [resetInactivityTimer, showScreensaver]);

  const handleDownloadAssets = async () => {
    setAssetDownloadProgress(null);
    setAssetDownloadComplete(null);
    setAssetDownloadError(null);

    if (window.electronAPI) {
      console.log(`Requesting asset download from: ${jsonUrl}`);
      window.electronAPI.downloadAssetsFromJSON(jsonUrl);
    } else {
      console.log("Electron API not available - fetching JSON directly");
      try {
        const response = await fetch(jsonUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const jsonData = await response.json();
        onDataReady(jsonData);
      } catch (error) {
        console.error("Failed to fetch JSON:", error);
        setAssetDownloadError(`Failed to fetch JSON: ${error.message}`);
        setSlides(initialSlides);
      }
    }
  };

  const onDataReady = (jsonData) => {
    setAppData(jsonData);
    console.log("onDataReady processing JSON:", jsonData, isElectron);

    //setStringValue("v0");// = "what?";

    if (jsonData) {
      const selectedShowcase = jsonData.object; // jsonData[2];
      if (selectedShowcase && Array.isArray(selectedShowcase)) {
        // not making a temporary model for the json data, just use it directly- less code.
        /*const newSlides = selectedShowcase.showcase_item.map(item => ({
          type: item.type || "image",
          thumbnail: item.thumbnail || "logo192.png",
          image: item.full_resolution_image || "logo192.png",
          video: item.video_file || "fingers.mov",
          title: item.title || "No Title",
          subtitle: item.subtitle || "",
          description: item.text || "No Description",
          themes: item.theme_list || [],
          media: item.media_item || {},
        }));*/
        var newSlides = selectedShowcase;
        //var newSlides = selectedShowcase.showcase_item.slice(0,7); // test different size arrays to adjust the rows/gallery size eg. >20=3 rows, >7=2 rows, <7 =1 row

        // generate a custom slide specific to the qr code overlay
        if(isElectron || true) {
          var qrCodeObjectSlide = { ...newSlides[0] }; // Create a shallow copy of the first slide
          // Modify the properties for the QR code view
          qrCodeObjectSlide.id = useGlobalStore.getState().visitExhibitionQRId; // 9999; // A unique ID for this static content
          qrCodeObjectSlide.id_number = qrCodeObjectSlide.id;
          qrCodeObjectSlide.sort_id = 9999; //qrCodeObjectSlide.id;
          qrCodeObjectSlide.mode = "static"; // this forces carousel to a modal popup
          qrCodeObjectSlide.title = "Visit online exhibition";
          qrCodeObjectSlide.subtitle = "About the Exhibition"; // Example subtitle
          qrCodeObjectSlide.about = "Scan the QR code to visit the Exhibition collection.";
          qrCodeObjectSlide.link = "https://www.unsw.edu.au/"; // Example link for the "More Info" button
          // qrCodeObjectSlide.media_item = [];
          qrCodeObjectSlide.type = "stories-qr";
          qrCodeObjectSlide.themes = [];
          newSlides.push(qrCodeObjectSlide); // Add the

          // also need another 'template' for video-qr code, which is very similar to stories-qr
          var qrCodeObjectSlideVideo = { ...newSlides[0] }; // Create a shallow copy of the first slide
          // Modify the properties for the QR code view
          qrCodeObjectSlideVideo.id = 9997; // A unique ID for this static content. this doesnd need a url
          qrCodeObjectSlideVideo.sort_id = qrCodeObjectSlideVideo.id;
          qrCodeObjectSlideVideo.mode = "static"; // this forces carousel to a modal popup
          qrCodeObjectSlideVideo.title = "Access online audio";
          qrCodeObjectSlideVideo.subtitle = "About the video"; // Example subtitle
          qrCodeObjectSlideVideo.about = "Scan the QR code to access our exhibition website and hear this video with audio.";
          qrCodeObjectSlideVideo.link = "https://www.unsw.edu.au/"; // Example link for the "More Info" button
          // qrCodeObjectSlide.media_item = [];
          qrCodeObjectSlideVideo.type = "video-qr";
          qrCodeObjectSlideVideo.themes = [];
          newSlides.push(qrCodeObjectSlideVideo); // Add the
        }

        // the 'about this exhibition' (top right) instead of the eletron qr code stuff needs to be inserted from the other json object - meh
        const exhibitionInfoData = jsonData.exhibition_info;
        const exhibitionGalleryData = jsonData.about_exhibition_media;
        var isHoldState = false;
        if (exhibitionInfoData) {
          setExhibitionTitle(exhibitionInfoData.exhibition_title || ''); // save the title for reuse in the gridgallery
          var aboutExhibitionSlide = { ...newSlides[0] }; // Create a shallow copy of the first slide
          // Modify the properties for the QR code view
          aboutExhibitionSlide.id = useGlobalStore.getState().exhibitionInfoId; // "exinfo-0"; // 9998; // A unique ID for this static content
          aboutExhibitionSlide.id_number = null; // the 'id_003' should NOT appear in the 'about this exhibition carousel
          aboutExhibitionSlide.sort_id = 9998; //aboutExhibitionSlide.id;
          //aboutExhibitionSlide.mode = "static";
          aboutExhibitionSlide.title =  exhibitionInfoData.exhibition_title || "Title";
          aboutExhibitionSlide.about = exhibitionInfoData.about_the_exhibition || '';
          //aboutExhibitionSlide.hold_state = exhibitionInfoData.hold_state;
          isHoldState = (exhibitionInfoData.hold_state === true || exhibitionInfoData.hold_state === 'true') ? true : false;
          if(isHoldState) {
            if(exhibitionInfoData.hold_state_title) {
              setDisableTouchScreensaverTexts(exhibitionInfoData.hold_state_title, exhibitionInfoData.hold_state_subheading);
            }
          }
          // FIXME: exhibitionInfoData doesnt have a custom title and subheading for the screensaver
          aboutExhibitionSlide.thumbnail = null;
          aboutExhibitionSlide.subtitle = null; // Example subtitle
          //aboutExhibitionSlide.text = "Scan the QR code to visit our website for more details about this exhibition and other collections. Scan the QR code to visit our website for more details about this exhibition and other collections. Scan the QR code to visit our website for more details about this exhibition and other collections.";
          aboutExhibitionSlide.link = null; //"https://www.unsw.edu.au/"; // Example link for the "More Info" button
          aboutExhibitionSlide.media_item = exhibitionGalleryData;
          aboutExhibitionSlide.type = "stories-about"; // about slides are hidden from gallery grid
          aboutExhibitionSlide.themes = [];
          //console.log("aboutExhibitionSlide", aboutExhibitionSlide);
          newSlides.push(aboutExhibitionSlide); // Add the
        }

        // the 'about this collection' (grid item 0) needs to be inserted from the other json object - meh
        // this needs to be updated/replaced everytime user changes filter
        // this was called 'stories-about' previously
        //var isHoldStateActiveOnThemeObject = null;
        const themesData = jsonData.theme_collection;
        if (Array.isArray(themesData)) {
          for(var aboutTheme of themesData) {
            if (aboutTheme) {
              //var customId = 9000+Number(aboutTheme.id);
              var customId = "theme-" + aboutTheme.id; // aboutTheme.touchscreen_id; // eg. 'TS1'
              // Create a new slide object from the theme data.
              const aboutSlide = {
                id: customId,
                sort_id: 0,
                type: 'stories-about',
                title: aboutTheme.title,
                about: aboutTheme.about_this_collection || '', // Assuming 'description' field exists on theme
                thumbnail: null, // Assuming thumbnail exists
                media_item: aboutTheme.about_media || [], // Ensure media_item exists
                themes: [String(aboutTheme.id)],
              };
              
              //console.log(aboutSlide);
              // Add this special slide to the beginning of the array to appear as grid item 0.
              newSlides.unshift(aboutSlide);
            }
          }
        }
          

        // the 'themes' are now just an array of ids that we need to use to extract the theme name from the other json object - meh
        if (Array.isArray(themesData)) {
          // Create a Map for efficient lookups. Using String() makes the lookup robust
          // against type mismatches (e.g., 123 vs "123").
          const themeMap = new Map(themesData.map(theme => [String(theme.id), theme.title]));
          newSlides.forEach(slide => {
            if (slide.themes && Array.isArray(slide.themes)) {
              slide.theme_list = slide.themes
                .map(themeId => themeMap.get(String(themeId))) // Use String() for robust lookup
                .filter(Boolean); // filter out undefined/null if an id is not found
            } else {
              slide.theme_list = [];
            }
          });
          console.log(newSlides);
        }

        // custom urlId assignment from 'id_number'
        // this is what will be displayed in the url
        newSlides.forEach(slide => {
          // need to strip id_number from html formatting ie. "<p>ID-053</p>"
          slide.urlId = slide.id_number ? new DOMParser().parseFromString(slide.id_number, 'text/html').body.textContent || slide.id : slide.id;
        });

        // final sort by 'sort_id'
        newSlides.sort((a, b) => a.sort_id - b.sort_id);
        console.log("Setting new slides:", newSlides);
        setSlides(newSlides);

        // screensaver slides are different to the normal slides- only appear for electron app when a theme is selected (query string)
        // - note we cant pre-select here because 'initialFilter' is NOT set
        const unselectedSS = jsonData.theme_collection;
        if(unselectedSS) {
          console.log("Setting raw screensaver slides (pre-filtered before initialFilter)", unselectedSS, initialFilter);
          setScreensaverSlides(unselectedSS);
        }
        

        setAssetDownloadError(null);
        //setShowDownloadStatus(false); // Hide the status UI after 5 seconds
        setTimeout(() => setShowDownloadStatus(false), 5000);

        // screensaver + disable touch custom cms flag: global flag (exhibition level)
        // Set the trigger to true; the effect will handle the isElectron check and calling handleStartScreensaver
        //console.log("cmsFlagDisableTouch", cmsFlagDisableTouch);
        const cmsFlagDisableTouch = isHoldState;
        if(cmsFlagDisableTouch) {
          setDisableTouchFlag(true);
          setTriggerScreensaverAfterInitialLoad(true);
        }

      } else {
        console.warn("showcase_item array not found or invalid in jsonData[1]");
        setSlides(initialSlides);
        setAssetDownloadError("Downloaded data structure is not as expected.");
      }
    } else {
      console.warn("jsonData is not in the expected array format or is too short.");
      setSlides(initialSlides);
      setAssetDownloadError("Downloaded data format is invalid.");
    }

    // after the INITIAL load, make sure nothing is in focus()- first tab should go direct to element[0] in grid
    document.activeElement.blur();

  };

  // after onDataReady() is called and screensaverSlides is populated, and we have the initialFilter - we can check if the custom hold_state for the selected theme is active
  // - this is the 2nd level of hold state (after exhibition level)
  useEffect(() => {
    //const selectedScreensaverSlides = getSelectedScreensaverSlides();
    //console.log("*** screensaverSlides+initialFilter changed", screensaverSlides.length, initialFilter);
    //console.log("*** getSelectedScreensaverSlides", selectedScreensaverSlides.length);
    if(isElectron && screensaverSlides.length > 0 && initialFilter) {
      console.log("***  has screensaverSlides and initialFilter for electron app:",screensaverSlides.length, initialFilter);
      const selectedScreensaverSlides = getSelectedScreensaverSlides(); // item 0
      if(selectedScreensaverSlides) {
        //if(selectedScreensaverSlides.hidden === true || selectedScreensaverSlides.hidden === 'true') {
        if(selectedScreensaverSlides.hold_state === true || selectedScreensaverSlides.hold_state === 'true') {
          // custom hold state for an individual theme (this should be called 'hold_state' instead of 'hidden'): if the initialfilter matches this aboutTheme.id, then we need to trigger the hold state
          // FIXME: initialFilter is NOT availabel here, so we cant apply the hold state until we know if this theme was selected or not
          console.log("* custom hold state for an individual theme detected (TODO: rename this from 'hidden' to 'hold_state'):", selectedScreensaverSlides.title, selectedScreensaverSlides.id, initialFilter, selectedScreensaverSlides);
          // NEW fields: hold_state_title and hold_state_subheading
          //isHoldStateActiveOnThemeObject = aboutSlide;
          //isHoldState = (exhibitionInfoData.hold_state === true || exhibitionInfoData.hold_state === 'true') ? true : false;
          if(selectedScreensaverSlides.hold_state_title) {
            setDisableTouchScreensaverTexts(selectedScreensaverSlides.hold_state_title, selectedScreensaverSlides.hold_state_subheading);
          }
          
          setDisableTouchFlag(true);
          setTriggerScreensaverAfterInitialLoad(true);
        } else {
          console.log("* NO custom hold state added for individual theme");
        }
      }

      
    }
    
    //, getSelectedScreensaverSlides
  }, [isElectron, screensaverSlides,initialFilter,getSelectedScreensaverSlides,setDisableTouchFlag,setTriggerScreensaverAfterInitialLoad,setDisableTouchScreensaverTexts]);

  useEffect(() => {
    // Function to check the media query and update the state
    const handleResize = () => {
      //console.log("handleResize called", window.outerWidth, window.outerHeight);
      const desktopMode = window.matchMedia('(min-width: 1025px)').matches;
      // Optional: Check if the value actually changed before setting
      // This can prevent unnecessary state updates if Zustand doesn't already optimize it
      if (desktopMode !== useGlobalStore.getState().isDesktop) {
         console.log("Resize detected, setting isDesktop to:", desktopMode);
         setDesktop(desktopMode);
      }

      // small mobile < 767px
      const smallMobileMode = window.matchMedia('(max-width: 767px)').matches;
      // Optional: Check if the value actually changed before setting
      // This can prevent unnecessary state updates if Zustand doesn't already optimize it
      if (smallMobileMode !== useGlobalStore.getState().isSmallMobile) {
         console.log("Resize detected, setting isSmallMobile to:", smallMobileMode);
         setSmallMobile(smallMobileMode);
      }
    };

    // Add the event listener when the component mounts
    window.addEventListener('resize', handleResize);

    // Call the handler once immediately on mount to set the initial state correctly
    handleResize();

    // Cleanup function: Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setDesktop,setSmallMobile]); // setDesktop is stable, so this effect essentially runs only on mount and unmount


  useEffect(() => {



    // --- Electron API Listeners Setup ---
    // ... (listeners remain the same) ...
    let removeCompleteListener = () => {};
    let removeErrorListener = () => {};
    let removeProgress = () => {};
    let removeAssetsComplete = () => {};
    let removeAssetsError = () => {};

    if (window.electronAPI) {
      console.log("Setting up Electron API listeners.");
      setElectron(true); // can now use this throughout the app

      removeCompleteListener = window.electronAPI.onDownloadComplete((filePath) => {
        console.log("Received single file path:", filePath);
        setDownloadedFile(filePath);
      });
      removeErrorListener = window.electronAPI.onDownloadError((error) => {
        console.error("Single download error:", error);
      });
      removeProgress = window.electronAPI.onAssetsDownloadProgress((progress) => {
        console.log("Assets Download Progress:", progress);
        setAssetDownloadProgress(progress);
      });
      removeAssetsComplete = window.electronAPI.onAssetsDownloadComplete((data) => {
        console.log("Assets Download Complete:", data);
        setAssetDownloadComplete(data);
        setAssetDownloadProgress(null);
        if (data.jsonData) {
          onDataReady(data.jsonData);
        } else {
          console.error("Assets download complete but jsonData is missing.");
          setAssetDownloadError("Assets download complete but data is missing.");
          setSlides(initialSlides);
        }
      });
      removeAssetsError = window.electronAPI.onAssetsDownloadError((error) => {
        console.error("Assets Download Error:", error);
        setAssetDownloadError(String(error));
        setAssetDownloadProgress(null);
        setSlides(initialSlides);
      });
    }

    // --- Trigger initial download only once ---
    if (!initialLoadDone.current) {
      // --- Read query parameter on initial mount ---
      const queryParams = new URLSearchParams(window.location.search);
      const filterFromUrl = queryParams.get('theme');
      if (filterFromUrl) {
        console.log("Found filter in URL:", filterFromUrl);
        setInitialFilter(filterFromUrl);
      }
      // --- Check for electron query parameter (web only testing) ---
      const electronParam = queryParams.get('electron');
      if (electronParam === '1') {
        console.log("Found 'electron=1' in URL. Forcing Electron mode.");
        setElectron(true);
      }
      // --- End query parameter reading ---
      // const cmsFlagDisableTouchParam = queryParams.get('disabletouch');
      // if (cmsFlagDisableTouchParam === '1') {
      //   console.log("Found 'disabletouch=1' in URL. Forcing screensaver.");
      //   //setDisableTouchScreensaver(true);
      //   setCmsFlagDisableTouch(true);
      // }
      

      console.log("handleDownloadAssets init launch (first run)");
      handleDownloadAssets();
      initialLoadDone.current = true;

      // before the INITIAL load, make sure nothing is in focus()- first tab should go direct to element[0] in grid
      document.activeElement.blur();
    }

    // --- Cleanup Function ---
    return () => {
      console.log("Cleaning up listeners");
      removeCompleteListener();
      removeErrorListener();
      removeProgress();
      removeAssetsComplete();
      removeAssetsError();
    };
  }, []);

  // Effect to synchronize viewMode and selectedSlideIndex with the URL
  useEffect(() => {
    let currentPath = location.pathname;

    // Normalize path for Electron on Windows: strip /X: prefix
    // Example: /C:/gallery/259 -> /gallery/259
    if (isElectron && currentPath.length > 3 && currentPath.startsWith('/') && currentPath[2] === ':' && currentPath[3] === '/') {
      console.log(`[App.js URL Sync Effect] Original Electron path: ${currentPath}`);
      currentPath = currentPath.substring(3); // Strips the /X: part, keeps the leading / for the actual path
      console.log(`[App.js URL Sync Effect] Normalized Electron path: ${currentPath}`);
    }

    const pathParts = currentPath.split('/').filter(Boolean); // e.g., ['gallery', '261'] or ['gallery', '261', 'mediaId']
    const viewContext = pathParts[0]; // Should be 'gallery' or undefined for root
    const itemIdFromUrl = pathParts[1];

    const queryParams = new URLSearchParams(location.search);
    const mediaIdFromQuery = queryParams.get('media'); // Get media ID from query
    console.log(`[App.js URL Sync Effect] Path: ${location.pathname} ${currentPath}, Search: ${location.search}, itemId: ${itemIdFromUrl}, mediaIdQuery: ${mediaIdFromQuery}, viewMode: ${viewMode}, modal: ${!!modalContent}`);

    if (!slides || slides === initialSlides || slides.length === 0) {
      console.log('[App.js URL Sync Effect] Slides not ready or initial.');
      return; // Data not ready
    }

    // --- Handle Carousel View and Modal from URL ---
    if (itemIdFromUrl) {
      const itemIndex = slides.findIndex(s => String(s.urlId) === String(itemIdFromUrl));
      if (itemIndex !== -1) {
        const targetSlide = slides[itemIndex];
        if (viewMode !== 'carousel' || selectedSlideIndex !== itemIndex) {
          console.log(`[App.js URL Sync Effect] Setting to CAROUSEL view for item ID ${itemIdFromUrl} (index ${itemIndex}).`);
          setSelectedSlideIndex(itemIndex);
          setViewMode('carousel');
        }

        // Now check for mediaIdFromQuery to open the modal
        if (mediaIdFromQuery) {
          // If the targetSlide is a "story" type with media_item array
          if (targetSlide.media_item && Array.isArray(targetSlide.media_item)) {
            const mediaToOpen = targetSlide.media_item.find(m => String(m.id) === String(mediaIdFromQuery));
            if (mediaToOpen) {
              if (!modalContent || String(modalContent.id) !== String(mediaIdFromQuery)) {
                console.log(`[App.js URL Sync Effect] Opening modal for mediaId ${mediaIdFromQuery} from story item ${itemIdFromUrl}.`);
                handleRequestOpenMediaItem(mediaToOpen);
              }
            } else {
              console.warn(`[App.js URL Sync Effect] mediaId ${mediaIdFromQuery} not found in story item ${itemIdFromUrl}. Clearing query.`);
              navigate(`/gallery/${itemIdFromUrl}`, { replace: true }); // Remove invalid media query
            }
          } else if (String(targetSlide.id) === String(mediaIdFromQuery) && (targetSlide.type === 'image' || targetSlide.type === 'video')) {
            // If the targetSlide is a direct image/video and its ID matches mediaIdFromQuery (URL is /gallery/itemId?media=itemId)
            if (!modalContent || String(modalContent.id) !== String(mediaIdFromQuery)) {
              console.log(`[App.js URL Sync Effect] Opening modal for direct item ${itemIdFromUrl} (mediaIdQuery matches item ID).`);
              handleRequestOpenMediaItem(targetSlide);
            }
          } else {
            console.warn(`[App.js URL Sync Effect] mediaId ${mediaIdFromQuery} present but item ${itemIdFromUrl} is not a story or mediaId doesn't match direct item. Clearing query.`);
            navigate(`/gallery/${itemIdFromUrl}`, { replace: true }); // Remove invalid media query
          }
        } else { // No mediaIdFromQuery, but we are in carousel view for itemIdFromUrl
          if (modalContent && String(modalContent.id) !== String(targetSlide.id)) {
            // If a modal is open for a DIFFERENT item than targetSlide (e.g. sub-item of a story), close it.
            console.log(`[App.js URL Sync Effect] In carousel view for ${itemIdFromUrl}, no mediaId in query. Modal for ${modalContent.id} open, target is ${targetSlide.id}. Closing modal.`);
            setModalContent(null);
          }
          // If the targetSlide itself is a direct viewable item (not a story)
          // then the URL /gallery/:itemId implies this item should be in the modal.
          if ((targetSlide.type === 'image' || targetSlide.type === 'video') &&
              !(targetSlide.media_item && targetSlide.media_item.length > 0)) {
            if (!modalContent || String(modalContent.id) !== String(targetSlide.id)) {
              console.log(`[App.js URL Sync Effect] Path /gallery/${itemIdFromUrl} is for a direct item. Opening modal.`);
              handleRequestOpenMediaItem(targetSlide);
            }
          }
        }
      } else {
        console.warn(`[App.js URL Sync Effect] Item ID ${itemIdFromUrl} from URL not found. Correcting URL to /gallery.`);
        navigate("/gallery", { replace: true });
      }
    } else if (viewContext === 'gallery' || location.pathname === '/') { // Check viewContext or root
      if (viewMode !== 'grid') {
        console.log('[App.js URL Sync Effect] On grid path. Setting to GRID view.');
        setViewMode('grid');
      }
      if (modalContent) { // If on grid path and modal is somehow open, close it.
        console.log('[App.js URL Sync Effect] On grid path and modal is open. Closing modal.');
        setModalContent(null);
      }
    }
  }, [location.pathname, location.search, slides, navigate, viewMode, selectedSlideIndex, modalContent, handleRequestOpenMediaItem]);

  // Effect to reset selectedSlideIndex after carousel fade-out
  useEffect(() => {
    const node = carouselSectionRef.current;
    if (!node) return;

    const handleTransitionEnd = (event) => {
      // Ensure we're listening for the opacity transition on the correct element
      if (event.target === node && event.propertyName === 'opacity') {
        // If the carousel has just finished fading out (viewMode is now 'grid')
        if (viewMode === 'grid' && selectedSlideIndex !== -1) {
          console.log("[App.js] Carousel fade-out complete. Resetting selectedSlideIndex.");
          setSelectedSlideIndex(-1);
        }
      }
    };

    node.addEventListener('transitionend', handleTransitionEnd);
    return () => {
      node.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, [viewMode, selectedSlideIndex]); // Rerun when viewMode or selectedSlideIndex changes

  // Effect to trigger screensaver after initial data load in Electron
  useEffect(() => {
    // This effect runs when `triggerScreensaverAfterInitialLoad` becomes true,
    // or when `slides`, `isElectron`, or `handleStartScreensaver` (itself dependent on slides) changes.
    if (triggerScreensaverAfterInitialLoad && isElectron && screensaverSlides && screensaverSlides.length > 0 && disableTouchFlag) {
      console.log("[App.js EffectForScreensaver] Initial data loaded in Electron. Conditions met. Calling handleStartScreensaver.", disableTouchFlag);
      // TODO: optional flag in data to DISABLE all touch interaction
      setDisableTouchScreensaver(disableTouchFlag);

      handleStartScreensaver()
      // setTimeout(() => {
      //   handleStartScreensaver(); // This will be the version of handleStartScreensaver
      //                           // created in the render cycle where `slides` is up-to-date.
      // }, 3000); // 100ms delay, can be adjusted
      
      setTriggerScreensaverAfterInitialLoad(false); // Reset the trigger so it doesn't run again unnecessarily

    }
  }, [triggerScreensaverAfterInitialLoad, screensaverSlides, isElectron, handleStartScreensaver, disableTouchFlag]);


  return (
    // Keep the main wrapper, it needs position: relative in CSS
    <div className={`gallery-wrapper-container view-${viewMode} ${isElectron ? 'is-electron' : 'is-web'}`}>
    {/* <div className={`gallery-wrapper-container is-electron view-${viewMode}`}> */}
    {/* <div className={`gallery-wrapper-container view-${viewMode}`}> */}
      {/* --- Download Status UI (Hidden) --- */}
      {/* --- UI for Asset Download (Conditionally Rendered) --- */}
      {isElectron && showDownloadStatus && (
        <div style={{ position: "absolute", bottom: "10px", left: "10px", background: "rgba(0,0,0,0.7)", color: "white", padding: "8px", borderRadius: "5px", zIndex: 100, fontSize: "12px" }}>
          {/* Close Button */}
          <button
            onClick={() => setShowDownloadStatus(false)}
            style={{
              position: 'absolute', top: '2px', right: '2px', background: 'none', border: 'none',
              color: 'white', fontSize: '14px', cursor: 'pointer', padding: '0 4px', lineHeight: '1'
            }}
            aria-label="Hide download status"
          >
            &times;
          </button>
          <button onClick={handleDownloadAssets} disabled={!!assetDownloadProgress} style={{ marginRight: '10px' }}>
            Download Assets from JSON
          </button>
          <p>{jsonUrl}</p>
          {assetDownloadProgress && (
            <>
              <p>Downloading: {assetDownloadProgress.downloaded} / {assetDownloadProgress.found} (Errors: {assetDownloadProgress.errors})</p>
              <p>{assetDownloadProgress.currentUrl}</p>
            </>
          )}
          {assetDownloadComplete && (
            <p>Asset Download Complete: {assetDownloadComplete.downloaded} successful, {assetDownloadComplete.errors} errors (out of {assetDownloadComplete.totalFound} found).</p>
          )}
          {assetDownloadError && (
            <p style={{ color: "red" }}>Error: {assetDownloadError}</p>
          )}
        </div>
      )}
      {/* --- End UI for Asset Download --- */}
      {/* ... download status content ... */}

      {/* --- Render BOTH sections, control visibility with classes --- */}
      <div ref={gridSectionRef} className={`grid-section ${viewMode === 'grid' ? 'active' : ''}`}>
        <GridGallery
          slides={slides}
          onImageClick={handleGridImageClick}
          initialFilter={initialFilter}
          viewMode={viewMode}
        />
      </div>

      <div
        ref={carouselSectionRef} // Attach the ref here
        className={`carousel-section ${viewMode === 'carousel' ? 'active' : ''}`}
      >
        <CarouselGallery
          isModal={checkCarouselIsModal(selectedSlideIndex)}
          initialSlideIndex={getInitialIndexForCarouselFromModalId(selectedSlideIndex)}
          slides={slides}
          selectedSlide={selectedSlideIndex >= 0 ? slides[selectedSlideIndex] : null}
          onClose={handleBackToGrid}
          onOpenMediaItemRequest={handleRequestOpenMediaItem} // App.js handles setting modalContent
          mode={ selectedSlideIndex >= 0 ? (slides[selectedSlideIndex].mode == 'static') ? 'static' : 'carousel' : 'carousel'}
        />
      </div>
      {/* --- End Rendering Sections --- */}


      
      {/* Button to trigger screensaver (example placement) */}
      {/* <button 
        onClick={handleStartScreensaver} // Uses the memoized version
        style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 1500 }}
      >
        Start Screensaver
      </button> */}
      {isElectron && showScreensaver && 
      <Screensaver 
        slides={getSelectedScreensaverSlides()} 
        disableTouchFlag={disableTouchFlag} 
        onClose={handleCloseScreensaver} />
      }

      {/* ZoomModal is now rendered and controlled by App.js state */}
      <ZoomModal
        ref={zoomModalRef}
        modalContent={modalContent}
        isOpen={!!modalContent}
        onClose={handleRequestCloseModal}
        onQR={handleRequestQRClick}
      />

      {/* custom QR code overlay for videos only */}
      <div
        className={`carousel-section qr-section ${(viewMode === 'carousel' && qrMode)  ? 'active' : ''}`}
      >
        <CarouselGallery
          isModal={true}
          initialSlideIndex={0}
          slides={slides}
          selectedSlide={slides[qrIndex >= 0 ? qrIndex : 0]}
          onClose={handleBackFromQR}
          onOpenMediaItemRequest={null} // App.js handles setting modalContent
          mode={'static'}
          customQrCodeAudioImage={audioQrCode}
        />
      </div>

    </div>
  );
};

export default App;
